import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Container,
  Paper,
  Typography,
  Button,
  Avatar,
} from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';
import { useLocalization } from '../../contexts/LocalizationContext';

const Profile: React.FC = () => {
  const { t } = useLocalization();
  const { user } = useAuth();
  const navigate = useNavigate();

  if ( !user ) {
    return null;
  }

  return (
    <Container maxWidth="md">
      <Paper sx={ { p: 4 } }>
        <Box sx={ { display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 3 } }>
          <Box sx={ { gridColumn: '1 / -1', display: 'flex', justifyContent: 'center' } }>
            <Avatar
              sx={ { width: 100, height: 100, fontSize: '2.5rem' } }
            >
              { user.name.charAt( 0 ).toUpperCase() }
            </Avatar>
          </Box>
          <Box sx={ { gridColumn: '1 / -1', textAlign: 'center' } }>
            <Typography variant="h4">
              { user.name }
            </Typography>
          </Box>
          <Box>
            <Typography variant="subtitle1" color="textSecondary">
              { t.common.email }
            </Typography>
            <Typography variant="body1">{ user.email }</Typography>
          </Box>
          {/* <Box>
            <Typography variant="subtitle1" color="textSecondary">
              {t.users.details.role}
            </Typography>
            <Typography variant="body1">{user.role || 'User'}</Typography>
          </Box> */}
          {/* <Box>
            <Typography variant="subtitle1" color="textSecondary">
              {t.common.status}
            </Typography>
            <Typography variant="body1">
              {user.status === 'active' ? t.users.management.active : t.users.management.inactive}
            </Typography>
          </Box> */}
          {/* <Box>
            <Typography variant="subtitle1" color="textSecondary">
              {t.users.details.createdAt}
            </Typography>
            <Typography variant="body1">
              {new Date(user.createdAt).toLocaleString()}
            </Typography>
          </Box> */}
          {/* <Box>
            <Typography variant="subtitle1" color="textSecondary">
              {t.users.details.updatedAt}
            </Typography>
            <Typography variant="body1">
              {new Date(user.updatedAt).toLocaleString()}
            </Typography>
          </Box> */}
          <Box sx={ { gridColumn: '1 / -1', display: 'flex', justifyContent: 'center', gap: 2 } }>
            <Button
              variant="contained"
              onClick={ () => navigate( '/change-password' ) }
            >
              { t.profile.changePassword }
            </Button>
            <Button
              variant="outlined"
              onClick={ () => navigate( '/' ) }
            >
              { t.profile.backToDashboard }
            </Button>
          </Box>
        </Box>
      </Paper>
    </Container>
  );
};

export default Profile;
